module.exports = "<kd-table-columns></kd-table-columns>\r\n<kd-table-headers\r\n    columns=\"$ctrl.columns.list()\"></kd-table-headers>\r\n<kd-table-row\r\n    ng-repeat=\"row in $ctrl.data track by $index\"\r\n    index=\"$index\"\r\n    data=\"row\"\r\n    columns=\"$ctrl.columns.list()\"></kd-table-row>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/kendu/ui/components/kd-table/template.html
// module id = 322
// module chunks = 0